import React from "react";
import { AiOutlineBank, AiOutlineMan, AiOutlineTeam, AiOutlineWoman } from "react-icons/ai";
import GroupListScreen from "../GroupListScreen";
import PersonCell from "../PersonCell";
import useGroupBranchOptions from "../useGroupBranchOptions";
import { fetchGroupStudents } from "../../../services/groupConsole.service";

const nameColumn = {
  title: "Name",
  key: "name",
  render: (r) => (
    <PersonCell
      id={r._id}
      image={r.profile_image}
      firstName={r.first_name}
      lastName={r.last_name}
      subtitle={r.gender}
    />
  ),
};

const buildStats = (rows) => {
  const total = rows.length;
  const male = rows.filter((r) => r.gender === "male").length;
  const female = rows.filter((r) => r.gender === "female").length;
  const branches = new Set(rows.map((r) => r.school)).size;
  return [
    {
      key: "total",
      label: "Students",
      value: total,
      icon: <AiOutlineTeam size={15} />,
      color: "indigo",
    },
    {
      key: "branches",
      label: "Branches",
      value: branches,
      icon: <AiOutlineBank size={15} />,
      color: "sky",
    },
    {
      key: "male",
      label: "Male",
      value: male,
      icon: <AiOutlineMan size={15} />,
      color: "blue",
    },
    {
      key: "female",
      label: "Female",
      value: female,
      icon: <AiOutlineWoman size={15} />,
      color: "rose",
    },
  ];
};

const GroupStudents = () => {
  const branches = useGroupBranchOptions();
  return (
    <GroupListScreen
      title="Students"
      queryKey="group-console-students"
      fetchFn={fetchGroupStudents}
      searchPlaceholder="Search by name, admission or roll no."
      branchOptions={branches.options}
      branchOptionsLoading={branches.isLoading}
      statCards={buildStats}
      pageSize={10}
      columns={[
        nameColumn,
        { title: "Admission No.", dataIndex: "admission_number", align: "center" },
        {
          title: "Class",
          key: "class",
          align: "center",
          render: (r) => r.class?.name || "—",
        },
      ]}
    />
  );
};

export default GroupStudents;
